import { API_AUTH } from "./common";

const twofactorApi = {
    generateQr: (userName) => API_AUTH.get(`/generate-qr/${userName}`),
    verifyOtp: (payload) => API_AUTH.post(`verify-otp`, payload),
    sendQr: (userName) => API_AUTH.post(`send-qr/${userName}`, {}),
}

export default twofactorApi;